const SOCIAL_NETWORKS = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    PINTEREST: 'pinterest',
    EMAIL: 'email',
    TUMBLR: 'tumblr',
};
export default SOCIAL_NETWORKS;
//# sourceMappingURL=socialNetworks.js.map